import { Link, NavLink } from "react-router-dom"
import * as Popover from "@radix-ui/react-popover"
import { faSignOut } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { config, cx } from "../utils"
import { authMachine } from "../machines/AuthMachine"

export const Header = () => {
  return (
    <header className="flex w-full flex-col items-center justify-center gap-4 sm:flex-row sm:justify-between">
      <Link to="/" className="block shrink-0">
        <img loading="lazy" src="/logo.png" alt="Recordsure Logo" className="w-full max-w-[2.25rem]" />
      </Link>
      <nav className="flex w-full items-center justify-center sm:justify-end gap-4">
        <AppLink to="/microservices">Microservices</AppLink>
        {config.documentServerEnabled && <AppLink to="/document-server">Document Server</AppLink>}
        <AppLink to="/microservices/search">Search</AppLink>
        <NavLink target="_blank" to={`${config.apiUrl}`} className="btn btn-sm cursor-pointer bg-grayish normal-case">
          Swagger
        </NavLink>
        <button
          type="button"
          onClick={() => authMachine.send({ type: "LOGOUT", everywhere: false })}
          className="btn-error btn-sm btn flex gap-1.5 normal-case"
        >
          <FontAwesomeIcon icon={faSignOut} />
          Log Out
        </button>
        <Popover.Root>
          <Popover.Trigger className="btn btn-outline btn-sm flex gap-1.5 normal-case">
            <FontAwesomeIcon icon={faSignOut} />
            Log Out Everywhere
          </Popover.Trigger>
          <Popover.Content side="bottom" sideOffset={2} align="center" className="rounded-md border bg-[white]">
            <Popover.Arrow className="fill-[white]" />
            <ul className="menu menu-vertical p-0">
              <li className="outline-none">
                <button type="button" onClick={() => authMachine.send({ type: "LOGOUT", everywhere: true })}>
                  Click to confirm
                </button>
              </li>
            </ul>
          </Popover.Content>
        </Popover.Root>
      </nav>
    </header>
  )
}

const AppLink = ({ to, children }: { to: string; children: string }) => (
  <NavLink
    to={to}
    className={({ isActive }) => cx("btn-sm btn cursor-pointer normal-case", isActive ? "btn-active" : "btn-outline")}
  >
    {children}
  </NavLink>
)
